export const DEFAULT_DATE_FORMAT = 'EEEE MMMM do, yyyy';
